/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SuspectedTradeUserLoader_user = {
    readonly verifiedTradeStatus: string | null;
    readonly serviceId: string | null;
    readonly isVip: boolean | null;
    readonly " $refType": "SuspectedTradeUserLoader_user";
};
export type SuspectedTradeUserLoader_user$data = SuspectedTradeUserLoader_user;
export type SuspectedTradeUserLoader_user$key = {
    readonly " $data"?: SuspectedTradeUserLoader_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspectedTradeUserLoader_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SuspectedTradeUserLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "verifiedTradeStatus",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVip",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'ce2b40ccc61594c7fdec5876f31642c8';
export default node;
